import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import {
  useAddDesignation,
  useGetDesignationColors,
  useUpdateDesignation,
} from "../MastersScreen/hooks/useSettingsMasters";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { Spinner } from "reactstrap";

interface DesignationTableModalContentProps {
  // handleSubmit: (e: React.FormEvent) => void;
  handleClose: () => void;
  modalStatus?: string;
  selectedRow?: any;
  setformData?: any;
  formData?: any;
  designationId?: string | number;
}

const DesignationTableModalContent: React.FC<
  DesignationTableModalContentProps
> = ({
  handleClose,
  modalStatus,
  selectedRow,
  setformData,
  formData,
  designationId,
}) => {
  console.log(
    "🚀 ~ DesignationTableModalContent.tsx:23 ~ DesignationTableModalContent ~ selectedRow:",
    selectedRow
  );

  const { data: designationColorsList } = useGetDesignationColors({
    enable: true,
  });

  const { mutate: addDesignation } = useAddDesignation();
  const { mutate: updateDesignation } = useUpdateDesignation();

  const formattedDesignationColorsData = Object.entries(
    designationColorsList?.data || {}
  ).map(([key, value]) => ({
    id: key,
    label: value as string,
  }));

  useEffect(() => {
    if (modalStatus === "Edit" && selectedRow) {
      setformData({
        name: selectedRow?.Designation,
        designationColor: selectedRow?.DesignationColor,
      });
    }
  }, [selectedRow]);

  const handleDropdownSelect = (field: string, value: string | number) => {
    setformData((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    const numericFields = ["attachment", "leavePoints"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setformData((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleSubmit = () => {
    if (modalStatus === "Edit" && selectedRow && designationId) {
      const updateDesignationBody = {
        designationName: formData?.name,
        designationColor: formData?.designationColor,
        designationId: designationId,
      };

      updateDesignation(
        { body: updateDesignationBody },
        {
          onSuccess: () => {
            handleClose();
            setformData({ name: "", designationColor: "" });
          },
          onSettled: () => {
            handleClose();
            setformData({ name: "", designationColor: "" });
          },
        }
      );
    } else {
      const addDesignationBody = {
        designationName: formData?.name,
        designationColor: formData?.designationColor,
      };

      addDesignation(addDesignationBody, {
        onSuccess: () => {
          handleClose();
          setformData({ name: "", designationColor: "" });
        },
        onSettled: () => {
          handleClose();
          setformData({ name: "", designationColor: "" });
        },
      });
    }
  };

  return (
    <>
      {selectedRow && modalStatus === "Edit" && !designationColorsList ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-md-12">
              <CustomInput
                label="Name*"
                placeholder="Enter Name"
                type="text"
                name="name"
                value={formData?.name}
                onChange={(e) => handleInputChange("name", e)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <RouteDropdown
                options={formattedDesignationColorsData || []}
                onChange={(value: any) => {
                  handleDropdownSelect("designationColor", value);
                }}
                value={formData?.designationColor}
                DropdownHeading="Designation Color"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              onClick={handleSubmit}
            >
              {modalStatus === "Edit" ? "Update" : "Submit"}
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </div>
      )}
    </>
  );
};

export default DesignationTableModalContent;
